import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

function Properties() {
  const [properties, setProperties] = useState([])
  const [filter, setFilter] = useState("All") // State for filtering
  const [currentPage, setCurrentPage] = useState(1) // State for pagination
  const itemsPerPage = 6 // Show 3 items per page

  useEffect(() => {
    fetch("/properties.json")
      .then(res => res.json())
      .then(data => setProperties(data))
  }, [])

  // 1. FILTER LOGIC
  // We filter the properties list based on the selected category
  const filteredProperties = properties.filter(item => {
    if (filter === "All") return true;
    return item.luxury.toLowerCase() === filter.toLowerCase();
  });

  // 2. PAGINATION LOGIC
  // Calculate indices based on the FILTERED list
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredProperties.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages based on filtered results
  const totalPages = Math.ceil(filteredProperties.length / itemsPerPage);

  // 3. HANDLER FUNCTIONS
  const handleFilterChange = (category) => {
    setFilter(category);
    setCurrentPage(1); // Reset to page 1 when category changes
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll up nicely
  };

  return (
    <div>
      <div className="page-heading header-text">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <span className="breadcrumb"><a href="#">Home</a> / Properties</span>
              <h3>Properties</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="section properties">
        <div className="container">
          
          {/* FILTER BUTTONS */}
          <ul className="properties-filter">
            <li>
              <a 
                className={filter === "All" ? "is_active" : ""} 
                onClick={() => handleFilterChange("All")} 
                href="#!"
              >Show All</a>
            </li>
            <li>
              <a 
                className={filter === "Apartment" ? "is_active" : ""} 
                onClick={() => handleFilterChange("Apartment")} 
                href="#!"
              >Apartment</a>
            </li>
            <li>
              <a 
                className={filter === "Luxury Villa" ? "is_active" : ""} 
                onClick={() => handleFilterChange("Luxury Villa")} 
                href="#!"
              >Villa House</a>
            </li>
            <li>
              <a 
                className={filter === "Penthouse" ? "is_active" : ""} 
                onClick={() => handleFilterChange("Penthouse")} 
                href="#!"
              >Penthouse</a>
            </li>
            <li>
              <a 
                className={filter === "Modern Condo" ? "is_active" : ""} 
                onClick={() => handleFilterChange("Modern Condo")} 
                href="#!"
              >Modern Condo</a>
            </li>
          </ul>

          {/* PROPERTY GRID */}
          <div className="row properties-box">
            {currentItems.length > 0 ? (
              currentItems.map((items) => {
                const propDetails = items.details[0];
                return (
                  <div className="col-lg-4 col-md-6 align-self-center mb-30 properties-items" key={items.id}>
                    <div className="item">
                      <Link to={"/propertydetails"}>
                        <img src={items.image} style={{ height: "270px", width: "100%", objectFit: "cover" }} alt={items.name} />
                      </Link>
                      <span className="category">{items.luxury}</span>
                      <h6>{items.price}</h6>
                      <h4><Link to={"/propertydetails"}>{items.name}</Link></h4>
                      <ul>
                        <li>Bedrooms: <span>{propDetails.Bedrooms}</span></li>
                        <li>Bathrooms: <span>{propDetails.Bathrooms}</span></li>
                        <li>Area: <span>{propDetails.Area}</span></li>
                        <li>Floor: <span>{propDetails.Floor}</span></li>
                        <li>Parking: <span>{propDetails.Parking}</span></li>
                      </ul>
                      <div className="main-button">
                        <Link to={"/propertydetails"}>Schedule a visit</Link>
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <div className="col-lg-12 text-center">
                <p>No properties found in this category.</p>
              </div>
            )}
          </div>

          {/* DYNAMIC PAGINATION */}
          <div className="row">
            <div className="col-lg-12">
              <ul className="pagination">
                {/* Back Arrow */}
                {currentPage > 1 && (
                  <li><a href="#!" onClick={() => paginate(currentPage - 1)}>&lt;</a></li>
                )}

                {/* Page Numbers */}
                {Array.from({ length: totalPages }, (_, i) => (
                  <li key={i + 1}>
                    <a 
                      href="#!" 
                      className={currentPage === i + 1 ? "is_active" : ""}
                      onClick={() => paginate(i + 1)}
                    >
                      {i + 1}
                    </a>
                  </li>
                ))}

                {/* Next Arrow */}
                {currentPage < totalPages && (
                  <li><a href="#!" onClick={() => paginate(currentPage + 1)}>&gt;</a></li>
                )}
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default Properties